import { render, staticRenderFns } from "./StaffDashboard.vue?vue&type=template&id=14666835&scoped=true&"
import script from "./StaffDashboard.vue?vue&type=script&lang=js&"
export * from "./StaffDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StaffDashboard.vue?vue&type=style&index=0&id=14666835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14666835",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VSimpleTable})
